import { Classes, NonIdealState } from "@blueprintjs/core";
import { DataTable2, IDataTable2Props, IDataTableProps } from "nsitools-react";
import * as React from "react";
import styled, { css } from "styled-components";

import { useTl } from "../../hooks";
import { ETLCodes } from "../../locales";
import { formatDate } from "../../utils";

export interface ICustomDataTableProps<T> extends IDataTable2Props<T> {
  searched?: boolean;
}

const Container = styled.div`
  .${Classes.HTML_TABLE} tr td .${Classes.CONTROL} {
    margin: 0;
  }
`;

export function CustomDataTable<T>(props: ICustomDataTableProps<T>) {
  const { searched } = props;
  const { t, tUnsafe } = useTl();
  return (
    <Container>
      <DataTable2
        {...props}
        formatDate={formatDate}
        translateFunc={tUnsafe}
        renderNoData={
          searched || searched === undefined ? (
            <NonIdealState icon="search" title={t(ETLCodes.GeneralNoData)} />
          ) : (
            <NonIdealState icon="series-search" title={t(ETLCodes.PleaseSelectCriteria)} />
          )
        }
      />
    </Container>
  );
}
